import 'css-chunksrc/client/pages/occupancyPage/toolbar/granularitySelector/styles.scss';export default {
  "granularitySelector": "_granularitySelector_150qg_1",
  "root": "_root_150qg_7",
  "input": "_input_150qg_11",
  "opened": "_opened_150qg_27",
  "icon": "_icon_150qg_32",
  "listRoot": "_listRoot_150qg_44",
  "list": "_list_150qg_44",
  "option": "_option_150qg_60",
  "selected": "_selected_150qg_66"
};